import React from "react";
import { useAppContext } from "src/hooks";
import { Iconify, TaskCreatedAt } from "src/components";
import { s3baseUrl } from "src/config";
import { truncateText } from "src/utils";
import { Avatar, Card, CardContent, Tooltip, Typography } from "@mui/material";
import moment from "moment";

export default function RecurringEventCard({ event, setOpenEventDialog, setSelectedEvent }) {
  const { dispatch_get_user_profile } = useAppContext();
  const userProfile = dispatch_get_user_profile();
  const handleClick = () => {
    setSelectedEvent(event?.more); 
    setOpenEventDialog(true); 
  };
  return (
    <Card
      className="dashboard-tasks-card"
      onClick={handleClick}
      variant="outlined"
    >
      <CardContent className="pb-0" sx={{ p: 0 }}>
        <div className="d-flex align-items-center gap-2  mb-2">
          <Iconify
            icon="pepicons-pencil:circle-filled"
            sx={{
              width: "16px",
              height: "16px",
              color: event.bg,
            }}
          />
          <Typography className="all-activetask-title">
            {truncateText(event.title, 65)}
          </Typography>
        </div>

        <div className="d-flex align-items-center gap-3">
          <Tooltip
            title={`Created by ${userProfile.first_name} ${userProfile.last_name}`}
          >
            <Avatar
              src={s3baseUrl + userProfile.image}
              sx={{ width: "30px", height: "30px" }}
            >
              {userProfile.first_name.substring(0, 2)}
            </Avatar>
          </Tooltip>

          <TaskCreatedAt date={event.start} />
        </div>
      </CardContent>
    </Card>
  );
}
